<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M10.0013 8.33464C11.8423 8.33464 13.3346 6.84225 13.3346 5.0013C13.3346 3.16035 11.8423 1.66797 10.0013 1.66797C8.16035 1.66797 6.66797 3.16035 6.66797 5.0013C6.66797 6.84225 8.16035 8.33464 10.0013 8.33464Z"
      fill="currentColor"
    />
    <path
      d="M12.8469 11.2588C12.0051 10.9894 11.0346 10.8359 10.0013 10.8359C6.77964 10.8359 4.16797 12.3284 4.16797 14.1693C4.16797 15.9531 6.62 17.4096 9.70305 17.4984C9.68047 17.3931 9.66297 17.2886 9.64922 17.186C9.58447 16.7046 9.58455 16.1164 9.58464 15.4909V15.3476C9.58455 14.7222 9.58447 14.1339 9.64922 13.6525C9.72122 13.1168 9.89338 12.5304 10.3779 12.0459C10.8625 11.5614 11.4488 11.3892 11.9846 11.3171C12.2446 11.2822 12.5356 11.2661 12.8469 11.2588Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7526 18.3333C12.3777 18.3333 11.6902 18.3333 11.2631 17.9062C10.8359 17.4791 10.8359 16.7916 10.8359 15.4167C10.8359 14.0418 10.8359 13.3543 11.2631 12.9272C11.6902 12.5 12.3777 12.5 13.7526 12.5C15.1275 12.5 15.815 12.5 16.2421 12.9272C16.6693 13.3543 16.6693 14.0418 16.6693 15.4167C16.6693 16.7916 16.6693 17.4791 16.2421 17.9062C15.815 18.3333 15.1275 18.3333 13.7526 18.3333ZM12.8 13.7767C12.6102 13.5868 12.3024 13.5868 12.1126 13.7767C11.9228 13.9665 11.9228 14.2742 12.1126 14.4641L13.0651 15.4167L12.1126 16.3693C11.9228 16.5591 11.9228 16.8668 12.1126 17.0567C12.3024 17.2465 12.6102 17.2465 12.8 17.0567L13.7526 16.1042L14.7052 17.0567C14.895 17.2465 15.2028 17.2465 15.3926 17.0567C15.5824 16.8668 15.5824 16.5591 15.3926 16.3693L14.4401 15.4167L15.3926 14.4641C15.5824 14.2742 15.5824 13.9665 15.3926 13.7767C15.2028 13.5868 14.895 13.5868 14.7052 13.7767L13.7526 14.7292L12.8 13.7767Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TaxpayersUnactivatedIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>